import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Col, Container, Modal, Row, Button } from 'react-bootstrap';
import MultiSelectDropdown from "../Controls/multiselectdropdown";
import Route from "./RoutingActions/Route";
import UnRoute from "./RoutingActions/UnRoute";
import APICom from '../../utils/helpers/APICom';
import PersistStorage from "../../utils/helpers/PersistStorage";


let clusterComboData = [];

const BuildManifest = (props) => {

    const [clusterFilterMultiSelect, setrouteFilterMultiSelect] = useState({ options: [], DropdownMode: 'rS', styles: { width: "98%", marginLeft: "0px" }, selectedValues: [] });
    const [isCreateNew, setIsCreateNew] = useState(true);
    const [showRouteActionCreate, setRouteActionCreate] = useState(false);
    const [showUnRouteActionCreate, setUnRouteActionCreate] = useState(false);
    const [disableUnRouteButton, setDisableUnRouteButton] = useState(true);
    const [disableAllButtons, setdisableAllButtons] = useState(false);
    const [force_assign, setforce_assign] = useState(false);
    const { loginData } = useSelector((store) => store.login);
    const [selectedManifest, setselectedManifest] = useState("");
    const [NoOfGroup, setNoOfGroup] = useState(-1);
    const [routeAlertObj, setRouteAlertObj] = useState({ alertTitle: '', alertMsg: '' });
    const [showRouteAlert, setRouteAlert] = useState(false);
    
    const [TableHeaders, setTableHeaders] = useState(["Route","Locked","Block","UnLocked","Selected For Day"]);
    const [showTableCols, setShowTableCols] = useState(false);
    const [routeDisplay, setRouteDisplay] = useState({});
    const addSingleTripToRoute = useRef(props.addtoRoute);
    const routeRef = useRef(props.addTripRoute);
    const [BtnTitle, setBtnTitle] = useState(<p className="m-0">Show Routes</p>);
    const [SelectedRouteSettingID, setSelectedRouteSettingID] = useState(-1);
    
    useEffect(() => {
        try{
            let groupOptions = [];
            const set = new Set();
            let affID = (props.selectedAffiliates.includes(",") ? props.selectedAffiliates.split(",")[0]:props.selectedAffiliates);
            GetRouteDropDownData(props.selectedDate, affID);
            const distinctGroup = [...new Set(props.GridRowData
                .map(data => data.Group)
                .filter(Group => Group)
            )];
            setNoOfGroup(distinctGroup.length);
            if(addSingleTripToRoute.current)
            {
                setDisableUnRouteButton(true);
                setIsCreateNew(false);
            }
            else
            {
                if (props.GridRowData !== undefined) {
                    props.GridRowData.forEach((data) => {
                        if (data.Route !== "") {
                            setDisableUnRouteButton(false);
                        }
                    });
                }
            }  

            if(props.triggerUnRoute)
            {
                handleUnRouteActionCreate();
                props.setTriggerUnRoute(false);
            }

           
        }
        catch(err){console.log(err);}
        
    }, [props.triggerUnRoute]);

    useEffect(() => {
        routeRef.current = props.addTripRoute;
    }, [props.addTripRoute]);

    // useEffect(() => {
    //     debugger;

    //     if (props.GridRowData.length = 1)
    //     {

    //         if (props.GridRowData[0].Route === '' && props.GridRowData[0].CallOutStatus === ''){
    //             setsingleUnroutedUnclustered(false)

    //         }

    //         else{
    //             setsingleUnroutedUnclustered(true)

    //         }
            

    //     }
        
    // }, );

    const handleCloseBuildManifestDialog = () => {
        if (props.showManifestBuildDialog) {
            props.setAddtoRoute(false);
            props.setManifestBuildDialog(false);
        }
    }

    const handleCheckboxChange = (event) => {
        if (event.target.value === "AddNew") {
            setIsCreateNew(true);
            setselectedManifest("");
        }
        else {
            setIsCreateNew(false);
        }
    };
    const handleRouteAlertClose = () =>{
        setRouteAlert(false);
    }

    // const handleRouteSuggestionAction = () => {

    // }

    const handleRouteActionCreate = (force_assign_called = false) => {
        if(isCreateNew === false){
            if(selectedManifest !== ''){
                PersistStorage.save("forceSelectedDate", props.selectedDate, 999, false);
                PersistStorage.save("forceManifestId",selectedManifest, 999, false);
                setforce_assign(force_assign_called);
                setRouteActionCreate(true);
                //setConfirmationModalObj();
            }
            else{
                setRouteAlertObj({ ...routeAlertObj, alertTitle: 'Routing Action', alertMsg: 'No Route is Selected!!!.' });
                setRouteAlert(true);
            }
        }
        else{
            //setConfirmationModalObj();
            setRouteActionCreate(true);
        }
    }

    const handleUnRouteActionCreate = () => {
        setUnRouteActionCreate(true);
    }

    const GetRouteDropDownData = async (date, aff) => {
        try{
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetRouteSummaryList?selected_date=" + date + "&affiliate_ids=" + aff  , "get", { "Content-Type": "application/json" }, null, null);
            clusterComboData = response.data;
            // console.log(response.data);
            let groupOptions = [];
            const set = new Set();
            if (clusterComboData !== undefined && clusterComboData !== "") {
                clusterComboData?.forEach((data) => {
                    if (data.ManifestNumber && !set.has(data.ManifestNumber)) {
                        set.add(data.ManifestNumber);
                        groupOptions.push({ "label": data.VirtualRoute, "value": data.ManifestNumber });
                    }
                });
            }
    
            if (groupOptions.length > 0) {
                setrouteFilterMultiSelect({ ...clusterFilterMultiSelect, options: groupOptions, selectedValues: groupOptions[0].value });
            }
            if(addSingleTripToRoute.current && props.GridRowData.length === 1)
            {
                RouteSelectCallback(routeRef.current);
            }
            else if(addSingleTripToRoute.current && props.GridRowData.length > 1)
            {
                RouteSelectCallback(routeRef.current);
            }
        }
        catch(err){console.log(err);}
    };

    const RouteSelectCallback = (_val) => {
        setselectedManifest(_val);
        if (_val !== "") {
            const selectedCluster = clusterComboData.find(data => data.ManifestNumber === _val);

            // Retrieve SettingID from the found object
            const SettingID = selectedCluster ? selectedCluster.iSettingID : null;

            setSelectedRouteSettingID(SettingID)

            PersistStorage.save("ManifestNumber", _val, 999, false);
            setrouteFilterMultiSelect({ ...clusterFilterMultiSelect, ...{ selectedValues: GetClusterSelectObjectBy(_val) } });
        }
    }

    // const handleRouteTableDisplay = async(e)=>{
    //     if(e.target.textContent === "Show Routes")
    //     {
    //         setBtnTitle(<span role='status' aria-hidden='true' className='spinner-border spinner-border-sm'></span>);
    //         let affID = (props.selectedAffiliates.includes(",")?props.selectedAffiliates.split(",")[0]:props.selectedAffiliates);
    //         let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetManifestARBRestriction?selected_date=" + props.selectedDate + "&affiliate_ids=" + affID
    //             , "get", { "Content-Type": "application/json" }, null, null);
    //         if(response.data !== null && response.data.length > 0)
    //         {
    //             setRouteDisplay(response.data);
    //             setShowTableCols(true);
    //             setBtnTitle(<p className="m-0">Hide Routes</p>);
    //         }
    //         else
    //         {
    //             setBtnTitle(<p className="m-0">Show Routes</p>);
    //         }
            
    //     }
    //     else
    //     {
    //         setShowTableCols(false);
    //         setBtnTitle(<p className="m-0">Show Routes</p>);
    //     }
    // }

    const GetClusterSelectObjectBy = (_vVal) => {
        try{
            let groupOptions = [];
            for (let ii = 0; ii < clusterComboData.length; ii++) {
                if (clusterComboData[ii].ManifestNumber === _vVal) {
                    groupOptions.push({ "label": clusterComboData[ii].VirtualRoute, "value": clusterComboData[ii].ManifestNumber });
                    break;
                }
            }
            return groupOptions;
        }
        catch(err){console.log(err);}
    }

    return (
        <>
            <Modal show={props.showManifestBuildDialog ? 1 : 0} centered onHide={handleCloseBuildManifestDialog} size="lg"
                aria-labelledby="contained-modal-title-vcenter" animation={true} keyboard={true} backdrop="static">
                <Modal.Header className='dispatch_action_dialog_header_bgcolor' closeButton>
                    <Modal.Title className='dispatch_action_dialog_title_color user-select-none' id="contained-modal-title-vcenter">
                        Route Actions
                    </Modal.Title>
                </Modal.Header>
                {props.GridRowData.length > 0 ? 
                    <>
                        <Modal.Body className="grid-example">
                            <Container>
                                <Row>
                                    <Col md={3} className="w-100">
                                        <span className="user-select-none">FOR TRIP : <b className="mx-2">{props.GridRowData.length > 1 ? props.GridRowData.length + " trips selected" : props.GridRowData[0]["ConfirmationNo"]}</b></span>
                                        <span className="firstRow text-nowrap user-select-none"> Number of Groups : <b className="mx-2">{NoOfGroup}</b></span>
                                    </Col>
                                </Row>
                                {/* <Row className="pt-2">
                                    <Col md={12} className="d-flex" >
                                        <label>Unique list of Mobility Attributes of Selected Trips: </label>
                                        <label id="lblMobilityAttributes" className="lblMobilityAttributes"></label>
                                    </Col>
                                </Row> */}
                                <Row className="pt-2">
                                    <Col xs={5} >
                                        <input type="radio" name="cluster_name" value="AddToExisting" onClick={handleCheckboxChange} readOnly checked={isCreateNew === false} />
                                        <label className="px-1 text-nowrap position-absolute user-select-none">Add to Existing Route</label>
                                    </Col>
                                    <Col xs={4} >
                                        <input type="radio" name="cluster_name" value="AddNew" onClick={handleCheckboxChange} readOnly checked={isCreateNew === true} />
                                        <label className="px-1 text-nowrap position-absolute user-select-none">Create Route(s)</label>
                                        
                                    </Col>
                                {/*<Col xs={3} className="d-flex justify-content-center">
                                        <Button variant="dark" className="text-nowrap" onClick={handleRouteTableDisplay}>{BtnTitle}</Button>
                            </Col>*/}
                                </Row>
                                
                                {isCreateNew === true ? null : (
                                    <>
                                        <Row className="pt-2">
                                            <Col md={4} className="d-flex user-select-none">
                                                <label>Route #</label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={4} className="d-flex">
                                                <MultiSelectDropdown options={clusterFilterMultiSelect} showCheckbox={false} className="w-100" SelectionChangeCallback={RouteSelectCallback} />
                                            </Col>
                                        </Row>
                                    </>
                                )}
                                
                            </Container>
                        </Modal.Body>
                        <Modal.Footer>
                            {/* <Button variant="dark" value="ForceAssign" onClick={() => handleRouteSuggestionAction()} disabled={singleUnroutedUnclustered}>Route Suggestion</Button> */}
                            <Button variant="dark" value="ForceAssign" onClick={() => handleRouteActionCreate(true)} disabled={isCreateNew}>ForceAssign</Button>
                            <Button variant="dark" value="Build Route" onClick={() => handleRouteActionCreate(false)} disabled={disableAllButtons}>Build Route</Button>
                            <Button variant="dark" value="Un-Route" onClick={handleUnRouteActionCreate} disabled={disableUnRouteButton || disableAllButtons}>Un-Route</Button>
                            {/*<Button variant="dark" title="Apply Routes Setting" onClick={handleApplyRoutesSetting} disabled={!showTableCols}>Apply</Button>*/}
                            <Button variant="dark" onClick={handleCloseBuildManifestDialog}>Close</Button>
                        </Modal.Footer>
                    </>
                :   
                    <>
                        <Modal.Body className="user-select-none fw-bold">{"Please select a trip first before routing/unrouting."}</Modal.Body>
                        <Modal.Footer>
                        
                            <Button variant="dark" onClick={handleCloseBuildManifestDialog}>OK</Button>
                        
                        </Modal.Footer>
                    </>
                }
            </Modal>

            {showRouteAlert && <Modal centered show={showRouteAlert} onHide={handleRouteAlertClose} >
                <Modal.Header closeButton>
                    <Modal.Title>{routeAlertObj.alertTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body><b>{routeAlertObj.alertMsg}</b></Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleRouteAlertClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>}

            {showRouteActionCreate ? <Route GridRefresh={props.GridRefresh} GridRowData={props.GridRowData} showRouteActionCreate={showRouteActionCreate} 
            setRouteActionCreate={setRouteActionCreate} disbaleButton={setdisableAllButtons} manifestNumber={isCreateNew ? "" : selectedManifest}
            setIsCreateNew= {isCreateNew} selectedDate={props.selectedDate} selectedAffiliates={props.selectedAffiliates} force_assign={force_assign} 
            SelectedRouteSettingID = {SelectedRouteSettingID}/> : "" }

            {showUnRouteActionCreate ? <UnRoute GridRefresh={props.GridRefresh} GridRowData={props.GridRowData} showUnRouteActionCreate={showUnRouteActionCreate} setUnRouteActionCreate={setUnRouteActionCreate} disbaleButton={setdisableAllButtons} selectedDate={props.selectedDate} selectedAffiliates={props.selectedAffiliates}/> : ""}
        </>
    );
}

export default BuildManifest;